module.exports = __webpack_public_path__ + "static/media/regedit_102.de8f1b84.ico";